import { getAllPrimaryTopics } from "@/services/events/topics.service";

export const DEFAULT_DAYS_FROM_END = 2;
export const DEFAULT_COUNTRY_CODE = "US";
export const SAVE_PREFS_INTERVAL_MINUTES = 5;

// these need to be in the order they would appear in th left sidebar
export const MAIN_MENU_SELECTORS = [
  "alerts",
  "events",
  "incidents",
  "influences",
  "media",
  "places",
  "profile",
  "stability",
  "hotspots",
  "search",
  "resources",
  "collaboration",
  "report",
  "dashboard",
  "esri",
  "signout",
  "saveSearch",
  "comms",
  "travelTracker",
  "powerOutage",
  "latest",
  "cyber",
  "firi",
  "notifications",
  "reporting",
  "grdHome",
  "grdCountries",
  "grdAboutUs",
  "assets",
  "globalIssues",
  "myIncidents",
];

export const MAINTENANCE_TYPES = {
  collaboration: {
    title: "Content Collaboration Currently in Maintenance",
    text: `
      <p>We are performing maintenance and unfortunately cannot make changes to your content folders.  This work is scheduled for between 5:00 PM Eastern Standard Time on Friday, January 14, 2022 and 3:00 AM Eastern Standard Time on Saturday, January 15, 2022.</p>
      <p>You can continue to add content to folders, however will be unable to view, edit, delete or create your content folders.  Any new content added to content folders during this time will be captured and restored to your content folders.</p>
      `,
  },
};

let detailSidebarTypes = {
  stability: "stability",
  news: "news",
  disasters: "disasters",
  travel: "travel",
  social: "social",
  mapClick: "map-click",
  alerts: "alerts",
  hotspots: "hotspots",
  places: "places",
  monitor: "monitor",
  controlRisksIncidents: "controlRisksIncidents",
  controlRisksRatings: "controlRisksRatings",
  isosProfiles: "isosProfiles",
  commMemberDetails: "commMemberDetails",
  powerOutage: "powerOutage",
  analysis: "analysis",
  eventsCharts: "eventsCharts",
  latest: "latest",
  grdHome: "grdHome",
  grdCountries: "grdCountries",
  grdAboutUs: "grdAboutUs",
  assets: "assets",
  myIncidents: "myIncidents",
};

export function setTopicDetailSidebarTypes() {
  // add the event topics to detailsidebar list
  const PRIMARY_TOPICS = getAllPrimaryTopics();
  PRIMARY_TOPICS.map((topic) => {
    detailSidebarTypes[topic.type] = topic.type;
  });
}

export const DETAIL_SIDEBAR_TYPES = detailSidebarTypes;

export const ARTICLE_CHANGE_PERIOD = 10000;

export const DEEP_LINK_URL_PATH_EXCEPTION_LIST = ["savedsearch"];
